module.exports = __webpack_public_path__ + "CM.png?b53a3f5d3ff005fef735bad3e5316550";